// src/features/settings/settingsService.js
import api from "../../api/api";

const getSettings = async () => {
  const response = await api.get("/settings");
  return response.data;
};

export default { getSettings };
